// ----------------------------------------------------------------------

const account = {
  displayName: 'User',
  email: 'teste@teste.com.br',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
